<template>
  <main class="main main--terms">
    <component
      :is="termsContent"
      class="group group--first-last group--indent typeset typeset--terms links"
    />
  </main>
</template>

<script>


// Models
import meta from 'models/meta';
import termsContent from 'models/content/terms.md';

// Utils
import { createMeta } from 'utils/meta';

// Export
export default {
  name: 'view-terms',

  // Meta data
  metaInfo: {
    title: meta.terms.title,
    meta: createMeta(meta.terms.meta),
  },

  // Data
  data() {
    return {
      termsContent,
    };
  },
};
</script>



// WEBPACK FOOTER //
// Terms.vue?4fbfeac7